import { DomSanitizer } from '@angular/platform-browser';
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string | null | undefined) {
    if (!value) {
      return ''; // null 또는 undefined일 경우 기본값 반환
    }
    // value = value.replace(/<|>/g, '');
    value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
